import React, {useEffect, useState} from 'react';
import styles from './transfer-instruction-modal-content.module.scss';
import {Row, Col, Button, Spinner} from 'react-bootstrap';
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  TRANSFER_INSTRUCTION_ERROR,
  TRANSFER_INSTRUCTION_SUCCESS
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import {useValidation} from "../../../../../../hooks/use-validation";
import {
  transferInstructionModalObj,
  transferInstructionModalValidator
} from "../../../../../../form-control/transfer-instruction-form/transfer-instruction-form-control";
import {DropDown, TextInput} from "../../../../../../components/form/form";
import SecondaryMarketService from "../../../../../../services/secondary-market-service";
import Transfer from "../../../../../../models/transfer";
import SecurityService from "../../../../../../services/security-service";

const TransferInstructionModalContent = ({context, onClose}) => {
  //Transfer instruction result variables
  const SUCCESS_TITLE = "TRANSFER INSTRUCTION SENT";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ page, setPage ] = useState(0);

  //Service call states
  const { setTransferList } = context;
  const [ securityList, setSecurityList ] = useState([]);
  const [ loading, setLoading] = useState(false);
  const secondaryMarketService = new SecondaryMarketService();
  const securityService = new SecurityService();

  useEffect(() => {
    const retrieveSecurityList = async () => {
      setLoading(true);
      try{
        const result = await securityService.getAllSecurities();
        console.log(result);
        setSecurityList(result.map(r => ({name: r.securityName, value: r.securityId})))
      }catch(error) {}
      finally {
        setLoading(false);
      }

    }
    retrieveSecurityList();
  }, []);

  //Validator
  const transferInstructionState = useValidation(
    transferInstructionModalValidator,
    transferInstructionModalObj({
      firstName: '',
      lastName: '',
      emailAddress: '',
      securityId: '',
    }),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getDropdownProps } = transferInstructionState;

  const send = async () => {
    const { formState, isFormValid } = validate();
    console.log(formState);
    if(!isFormValid){
      return
    }
    setLoading(true);
    try {
      const securityName = securityList.filter(s => s.value === formState.securityId)
      formState['securityName'] = securityName.length > 0 ? securityName[0].name : '';
      const createdTransfer = await secondaryMarketService.createTransfer(formState);
      setTransferList(prev => {
        const newList = prev.concat(new Transfer(createdTransfer));
        return newList;
      });
      setPage(1);
    }catch(error){
      setPage(2);
    }finally {
      setLoading(false);
    }
  }
  const renderTransferInstructionResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={TRANSFER_INSTRUCTION_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={TRANSFER_INSTRUCTION_ERROR} onClose={onClose}/>
      default:
    }
  }

  const getSecurityList = () => {
    return [
      { name: 'AEV Series C Fixed Rate Bonds Due 2023', value: 'aevscfrbd2023' },
      { name: 'AEV Series D Fixed Rate Bonds Due 2025', value: 'aevscfrbd2025' }
    ]
  }

  return page === 0 ? (
    <div className={styles['transfer-instruction-modal-content']}>
      <Row>
        <Col lg={{offset: 1, span: 10}}>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('lastName')} placeholder={""}>
                Last Name:*
              </TextInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('firstName')} placeholder={""}>
                First Name:*
              </TextInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('emailAddress')} placeholder={""}>
                Email Address:*
              </TextInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <DropDown inputProps={getDropdownProps('securityId')} values={securityList}>
                Security:*
              </DropDown>
            </Col>
          </Row>
          <Row className={styles['button-row']}>
            <Col xs={6} lg={6}>
              <div className={styles['cancel-button']}>
                <Button variant="secondary" onClick={() => onClose()}>
                  CANCEL
                </Button>
              </div>
            </Col>
            <Col xs={6} lg={6}>
              <div className={styles['send-button']}>
                <Button disabled={loading} onClick={() => send()}>
                  {loading ? <Spinner size="sm" animation="border"/> : 'SEND'}
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : renderTransferInstructionResult()
}

export default TransferInstructionModalContent;
